<template>
  <v-skeleton-loader v-if="loading" type="article" />
  <v-simple-table v-else dense>
    <tbody>
      <tr>
        <td class="text--secondary" style="width: 180px">Nome</td>
        <td>{{ user?.name || "Conta não criada" }}</td>
      </tr>
      <tr>
        <td class="text--secondary">Telefone</td>
        <td>{{ phone }}</td>
      </tr>
      <tr>
        <td class="text--secondary">E-mail</td>
        <td>
          <i v-if="!user?.email">Não informado</i>
          <span v-else>{{ user.email }}</span>
        </td>
      </tr>
      <tr>
        <td class="text--secondary">{{ documentLabel }}</td>
        <td>
          <i v-if="!user?.document">Não informado</i>
          <span v-else>{{ user.document }}</span>
        </td>
      </tr>
      <tr>
        <td class="text--secondary">Nascimento</td>
        <td>
          <i v-if="!user?.birthday">Não informado</i>
          <span v-else>
            {{ $options.filters.date(user.birthday, "DD/MM/YYYY") }} •
            {{ userAge }} anos
          </span>
        </td>
      </tr>
      <tr>
        <td class="text--secondary">Criado em</td>
        <td>
          <v-tooltip v-if="user?.createdAt" top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ user.createdAt | date("DD/MM/YYYY HH:mm") }}
              </span>
            </template>
            <span>{{ [user.createdAt] | dateDiff(true) }}</span>
          </v-tooltip>
          <span v-else>Não informado</span>
        </td>
      </tr>
      <tr>
        <td class="text--secondary">Cadastro</td>
        <td>
          <v-chip
            x-small
            label
            :color="user?.complete ? 'success' : 'warning'"
            text-color="white"
          >
            {{ user?.complete ? "Completo" : "Incompleto" }}
          </v-chip>
        </td>
      </tr>
      <tr>
        <td class="text--secondary">Situação</td>
        <td>
          <v-chip
            x-small
            label
            :color="user?.active ? 'success' : 'error'"
            text-color="white"
          >
            {{ user?.active ? "Ativo" : "Inativo" }}
          </v-chip>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import moment from "moment";

const DOCUMENT_LABELS = {
  CPF: "CPF",
  EXTRANGER: "Documento estrangeiro",
  PASSPORT: "Passaporte",
};

export default {
  name: "UserBasic",
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    phone() {
      if (!this.user?.phone) return "Não informado";
      return `+${this.user.ddi || 55} ${this.user.phone}`;
    },
    documentLabel() {
      return DOCUMENT_LABELS[this.user?.documentType] || "Documento";
    },
    userAge() {
      if (!this.user?.birthday) return "";
      return moment().diff(moment(this.user.birthday), "years");
    },
  },
  filters: {
    date(value, format = "DD/MM/YYYY") {
      if (!value) return "";
      return moment(value).format(format);
    },
  },
};
</script>
